"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParkingList = void 0;
const system_1 = __importDefault(require("@/pages/index/api/system"));
const location_1 = require("@/pages/index/select/location");
const config_1 = require("@/config/dictionary/config");
const utils_1 = require("@/config/utils");
const TotalComplexList_1 = __importDefault(require("@/class/TotalComplexList"));
const complex_1 = require("@/pages/index/select/complex");
class ParkingList extends TotalComplexList_1.default {
    buildItem(postData) {
        return new Promise((resolve, reject) => {
            system_1.default.parkingPointBuild.require(postData).then(() => {
                this.$reloadData({
                    force: true,
                    change: true
                }).finally(() => {
                    resolve({ status: 'success' });
                });
            }).catch(err => {
                // eslint-disable-next-line no-console
                console.error(err);
                reject(err);
            });
        });
    }
    changeItem(postData, originData) {
        return new Promise((resolve, reject) => {
            postData.id = originData.id;
            system_1.default.parkingPointChange.require(postData).then(() => {
                this.$reloadData({
                    force: true,
                    change: true
                }).finally(() => {
                    resolve({ status: 'success' });
                });
            }).catch(err => {
                // eslint-disable-next-line no-console
                console.error(err);
                reject(err);
            });
        });
    }
    deleteItem() {
        return new Promise((resolve, reject) => {
            system_1.default.parkingPointDelete.require(this.$module.choice.getId()).then(() => {
                this.$module.choice.$reset();
                this.$reloadData({
                    force: true,
                    change: true
                }).finally(() => {
                    resolve({ status: 'success' });
                });
            }).catch(err => {
                // eslint-disable-next-line no-console
                console.error(err);
                reject(err);
            });
        });
    }
}
exports.ParkingList = ParkingList;
const parkingPoint = new ParkingList({
    name: '停车点',
    prop: 'parkingPoint',
    select: complex_1.parkingPointSelect,
    module: {
        pagination: true,
        choice: {},
        search: {
            module: {
                dictionary: {
                    layout: {
                        default: {
                            grid: 6,
                            label: 8,
                            content: 16
                        }
                    },
                    list: [
                        {
                            prop: 'parkPointName',
                            name: '停车点名称',
                            originProp: 'parkPointName',
                            originFrom: 'list',
                            mod: {
                                search: {
                                    $type: 'edit',
                                    type: 'input',
                                    option: {
                                        maxLength: 100
                                    }
                                }
                            }
                        },
                    ]
                }
            },
            menu: {
                list: []
            },
        },
        dictionary: {
            layout: {
                default: {
                    grid: 24,
                    label: 7,
                    content: 17
                }
            },
            option: {},
            propData: {
                id: 'id'
            },
            list: [
                {
                    prop: 'id',
                    name: 'ID',
                    originProp: 'id',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'parkPointName',
                    name: '停车点名称',
                    originProp: 'parkPointName',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.getWidth(12)
                        },
                        edit: {
                            type: 'input',
                            required: true,
                            option: {
                                maxLength: 50
                            }
                        },
                        build: {
                            $target: 'edit'
                        },
                        change: {
                            $target: 'edit'
                        }
                    }
                },
                {
                    prop: 'contactName',
                    name: '联系人',
                    originProp: 'contactName',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.personnelName
                        },
                        edit: {
                            type: 'input',
                            required: true,
                            option: {
                                maxLength: 20
                            }
                        },
                        build: {
                            $target: 'edit'
                        },
                        change: {
                            $target: 'edit'
                        }
                    }
                },
                {
                    prop: 'contactPhone',
                    name: '联系人电话',
                    originProp: 'contactPhone',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.phone
                        },
                        edit: {
                            type: 'input',
                            required: true,
                            option: {
                                maxLength: 20
                            },
                            rules: [
                                {
                                    validator(rule, val) {
                                        if (val) {
                                            if (utils_1.RegExpRule.mobilePhone.test(val) || utils_1.RegExpRule.linePhone.test(val)) {
                                                return Promise.resolve();
                                            }
                                            else {
                                                return Promise.reject();
                                            }
                                        }
                                        return Promise.reject();
                                    },
                                    message: '请输入正确的手机号码'
                                }
                            ]
                        },
                        build: {
                            $target: 'edit'
                        },
                        change: {
                            $target: 'edit'
                        }
                    }
                },
                {
                    prop: 'provincecode',
                    showProp: {
                        default: 'value',
                        list: 'label'
                    },
                    name: '省市',
                    originProp: 'provincecode',
                    originFrom: 'list',
                    format(value, { originData }) {
                        const cityCode = originData.citycode;
                        const provinceValue = location_1.location.getItem(value);
                        const valueList = [value, cityCode];
                        if (cityCode && provinceValue.children) {
                            const cityValue = provinceValue.children.find(item => item.value === cityCode);
                            return {
                                value: valueList,
                                label: cityValue.label
                            };
                        }
                        return {
                            value: valueList,
                            label: provinceValue.label
                        };
                    },
                    post(value, { targetData }) {
                        const [provinceCode, cityCode] = value;
                        targetData.citycode = cityCode;
                        return provinceCode;
                    },
                    mod: {
                        edit: {
                            type: 'cascader',
                            required: true,
                            option: {
                                list: location_1.location.getList()
                            }
                        },
                        build: {
                            $target: 'edit'
                        },
                        change: {
                            $target: 'edit'
                        }
                    }
                },
                {
                    prop: 'address',
                    name: '详细地址',
                    originProp: 'address',
                    originFrom: 'list',
                    mod: {
                        edit: {
                            type: 'input',
                            required: true,
                            option: {
                                maxLength: 100
                            }
                        },
                        build: {
                            $target: 'edit'
                        },
                        change: {
                            $target: 'edit'
                        }
                    }
                },
                {
                    prop: 'location',
                    name: '地址',
                    originProp: 'location',
                    originFrom: 'local',
                    show(value, { targetData }) {
                        return (targetData.provincecode.label || '') + (targetData.address || '');
                    },
                    mod: {
                        list: {
                            width: config_1.listWidth.getWidth(20)
                        }
                    }
                },
                {
                    prop: 'status',
                    name: '状态',
                    originProp: 'status',
                    originFrom: 'list',
                    format(value) {
                        return value === 1;
                    },
                    show(value) {
                        return value ? '启用' : '禁用';
                    },
                    post(value) {
                        return value ? 1 : 0;
                    },
                    mod: {
                        list: {
                            width: config_1.listWidth.getWidth(2)
                        },
                        edit: {
                            type: 'switch',
                            required: true,
                            value: {
                                default: true
                            },
                            local: {
                                target: {
                                    props: {
                                        checkedChildren: '启用',
                                        unCheckedChildren: '禁用'
                                    }
                                }
                            }
                        },
                        build: {
                            $target: 'edit'
                        },
                        change: {
                            $target: 'edit'
                        }
                    }
                },
                {
                    prop: 'signBeginTime',
                    name: '签约时间',
                    format(value, { originData }) {
                        if (value && originData.signEndTime) {
                            return [value, originData.signEndTime];
                        }
                    },
                    show(value) {
                        return value ? value.join(' - ') : '';
                    },
                    post(value, { targetData }) {
                        if (value && value.length === 2) {
                            targetData.signEndTime = value[1];
                            return value[0];
                        }
                    },
                    originProp: 'signBeginTime',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: 205
                        },
                        edit: {
                            type: 'dateRange',
                            width: '100%',
                            required: false,
                            option: {
                                show: 'YYYY/MM/DD'
                            }
                        },
                        build: {
                            $target: 'edit'
                        },
                        change: {
                            $target: 'edit'
                        }
                    }
                },
                {
                    prop: 'remark',
                    name: '备注',
                    originProp: 'remark',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'createdName',
                    name: '创建人',
                    originProp: 'createdName',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.personnelName
                        }
                    }
                },
                {
                    prop: 'createdBy',
                    name: '创建人',
                    originProp: 'createdBy',
                    originFrom: 'list',
                },
                {
                    prop: 'createdTime',
                    name: '创建时间',
                    originProp: 'createdTime',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.time
                        }
                    }
                },
                {
                    prop: 'updatedBy',
                    name: '最后更新人',
                    originProp: 'updatedBy',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'updatedTime',
                    name: '更新时间',
                    originProp: 'updatedTime',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'menu',
                    name: '操作',
                    originProp: 'menu',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.getWidth(2)
                        }
                    }
                },
            ]
        }
    }
});
exports.default = parkingPoint;
